import { render, staticRenderFns } from "./characterManage.vue?vue&type=template&id=19377bf1&scoped=true"
import script from "./characterManage.vue?vue&type=script&lang=js"
export * from "./characterManage.vue?vue&type=script&lang=js"
import style0 from "./characterManage.vue?vue&type=style&index=0&id=19377bf1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19377bf1",
  null
  
)

export default component.exports